export const LOAD_LEVELS_REQUEST = '[levels] load request';
export const LOAD_LEVELS_SUCCESS = '[levels] load success';
export const LOAD_LEVELS_FAILURE = '[levels] load failure';
export const SET_DIFFICULTY = '[levels] set difficulty';
